import type {HTMLAttributes, ReactNode} from 'react';

import {cn} from '../../../helpers/cn';

export type MobileLayoutProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

/** 480px max-width mobile shell — matches the app container on any viewport. */
export function MobileLayout({children, className, ...props}: MobileLayoutProps) {
  return (
    <div
      className={cn('mx-auto min-h-dvh w-full max-w-mobile overflow-x-hidden bg-white', className)}
      {...props}
    >
      {children}
    </div>
  );
}
